const USER = 10;
const ADMIN = 50;

const ROLES = {
  USER,
  ADMIN,
};

export default ROLES;